<script setup lang="ts">
</script>

<template>
  <div
    class="h-full"
  >
    <router-view />
  </div>
</template>
